import { createSelector } from 'reselect';
import get from 'lodash/get';
import { selectedGoal } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  recurring,
  oneTime,
} from './LargePurchaseAssumptionsConst';

export const hasRecursionFrequency = (frequency) => {
  const minYear = 1;
  const repeatForNYears = Object.keys(frequency).find(item => frequency[item] > minYear);
  return !!repeatForNYears;
};

export const isRecurring = goal => (
  hasRecursionFrequency(get(goal, 'Frequency', {}))
);

export const largePurchaseAssumptions = ({ GoalAssumptions }) => (
  isRecurring(GoalAssumptions) ? recurring : oneTime
);

export const assumptionValuesSelector = createSelector(
  selectedGoal,
  ({ GoalAssumptions }) => GoalAssumptions,
);

export const assumptionsLabelSelector = createSelector(
  selectedGoal,
  goal => largePurchaseAssumptions(goal),
);
